import { atom } from 'jotai';
import { PaymentMethodDto } from 'interfaces/paymentMethods';

export const paymentMethodsAtom = atom<PaymentMethodDto[]>([]);
